var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('v-chip',_vm._g(_vm._b({attrs:{"color":_vm.color,"small":!_vm.xSmall,"x-small":_vm.xSmall,"text-color":"white"}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t(`quotations.statuses.${_vm.status}`))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }